import { PaginatedDtoSchema } from "@core/data/dto/paginated.dto.ts";
import { ReportStationSummaryDtoSchema } from "@report/data/dto/report-station.dto.ts";
import * as z from "zod";

const ReportStationTraveledKilometersDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.number(),
        station: ReportStationSummaryDtoSchema,
        pagination: PaginatedDtoSchema,
    })
    .readonly();

export const ReportTraveledKilometersDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.record(z.string(), ReportStationTraveledKilometersDtoSchema),
        total: z.number(),
    })
    .readonly();

export type ReportTraveledKilometersDto = z.output<
    typeof ReportTraveledKilometersDtoSchema
>;
